<script lang="ts" setup>
import type {ComponentLayoutCardColumns} from '~~/types/strapi-blog';

const props = defineProps<ComponentLayoutCardColumns>();
</script>

<template>
    <UPageSection
        :ui="{ container: 'sm:gap-16 py-8 sm:py-8 lg:py-8 gap-16 sm:gap-8' }"
        class="lg:first:pt-12"
    >
        <div class="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <UCard
                v-for="(card, index) in props.cards"
                :key="index"
            >
                <template #header>
                    <NuxtPicture
                        v-if="card.image"
                        :alt="card.image?.alternativeText ?? ''"
                        :src="useStrapiMedia(card.image?.url)"
                        class="aspect-square object-cover"
                    />
</template>
                <template
                    v-if="card.description"
                    #default
                >
                    <div v-html="card.description"/>
                </template>
                <template
                    v-if="card.button"
                    #footer
                >
                  <UButton
                        :href="card.button.url"
                        :label="card.button.label"
                  />
                </template>
            </UCard>
        </div>
    </UPageSection>
</template>
